import styled from "styled-components";

export const FooterContainer = styled.footer`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  padding: 0em 1em;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #F0F5FF;
//   color: white;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
    height: 60px;
    position: fixed;
    padding: 0em 0.7em;
    bottom: 0;
  }
`;
export const Copy = styled.div`
  display: flex;
  margin-right: auto;
`;
export const Languages = styled.div`
  display: flex;
  div {
    margin-right: 10px;
    text-decoration: none;
    cursor: pointer;
    opacity: 0.5;
  }

  div:last-child {
    margin-right: 0px;
  }
  div.active {
    margin-right: 10px;
    text-decoration: none;
    cursor: pointer;
    opacity: 1;
  }
  @media screen and (max-width: 768px) {
    div {
      color: black;
    }
    div.active {
      color: #198ad6;
    }
  }
`;
export const Nav = styled.nav`
  display: flex;
  // margin-left: auto;
  gap: 100px;
  a {
    color: #000000;
    margin-right: 10px;
    text-decoration: none;
  }
  a:last-child {
    margin-right: 0px;
  }
  @media screen and (max-width: 1200px) {
    gap: 50px;
  }
  @media screen and (max-width: 768px) {
   width: 100%;
    margin-left: inherit;
    gap: 0px;
    justify-content: space-between;
  }
`;
